// src/app/store/app.reducers.ts

import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.states';

import { supplierReducer } from './suppliers/supplier.reducer';
import { companiesReducer } from './companies/companies.reducer';
import { hsnReducer } from './hsn-code/hsn.reducer';
import { itemReducer } from './item/item.reducer';
import { CategoriesReducer } from './categories/category.reducer';
import { batchReducer } from './batch/batch.reducers';
import { DoctorReducer } from './doctor/doctor.reducers';
import { companyGroupReducer } from './company-group/company-group.reducer'; // <-- Import the reducer
import { purchaseFormReducer } from './purchase/purchase.reducers';
import { salesReducer } from './sales/sales.reducer';
import { storageRackReducer } from './storage-rack/storage-rack.reducer';
import { scheduleReducer } from './schedule/schedule.reducer';
import { purchaseReturnReducer } from './purchase-return/purchase-return.reducer';
import { bankReducer } from './bank/bank.reducers';
import { rolesReducer } from './roles/roles.reducer';

export const appReducer: ActionReducerMap<AppState> = {
  suppliers: supplierReducer,
  companies: companiesReducer,
  hsn: hsnReducer,
  item: itemReducer,
  categories: CategoriesReducer,
  batch: batchReducer,
  doctor: DoctorReducer,
  companyGroup: companyGroupReducer, // <-- Add the missing reducer
  purchase: purchaseFormReducer,
  sales: salesReducer,
  schedule: scheduleReducer,
  storageRack: storageRackReducer, // Add the user management reducer
  purchaseReturn: purchaseReturnReducer,
  bank: bankReducer,
  roles: rolesReducer,
};
